import { twMerge } from 'tailwind-merge'
import { HTMLString } from 'shared/types/html-string'

export type FieldErrorAndDescriptionProps = {
  description?: React.ReactNode
  descriptionClassName?: string
  error?: HTMLString | string | null
  errorClassName?: string
}

export const FieldErrorAndDescription = ({
  description,
  descriptionClassName,
  error,
  errorClassName,
}: FieldErrorAndDescriptionProps) =>
  (error || description) && (
    <div>
      {description && (
        <span
          className={twMerge('text-sm opacity-70 [&>a]:text-brand-primary', descriptionClassName)}
        >
          {description}
        </span>
      )}
      {error && (
        <p
          className={twMerge('text-sm text-danger', errorClassName)}
          dangerouslySetInnerHTML={{ __html: error }}
        />
      )}
    </div>
  )
